import { Component, OnInit, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { EpGridComponent, IEpGridModel, EpGridEvent, IEpGridSelectionOptions, IEpGridState, IEPGridDataResult, EpButtonStyle, IEpComponentEventArg } from '@epicor/kinetic';
import { BistrackConfig, LocalStorageSaveTypes, PageNames, SearchPageNames } from 'ep-bt-controls';
import { Observable } from 'rxjs';
import { FieldAgentClient, CustomerSearchParameters, CustomerSearchParametersCustomerStatus, CustomerSearchParametersDeliverytype,
  SortParametersDirection, PagingParameters, SortParameters } from 'ep-bt-field-agent-proxy';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { Router } from '@angular/router';
import { EpbtFaCustomerService } from '../../services/epbt-fa-customer.service';
import { Location } from '@angular/common';
import { EpbtFaQuickOrderService } from '../../services/epbt-fa-quick-order.service';
import { EpbtFaContactsService } from '../../services/epbt-fa-contacts.service';
import { EpbtFaSortService } from '../../services/epbt-fa-sort.service';

declare var $: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-contacts-grid',
  templateUrl: './epbt-fa-contacts-grid.component.html',
  styleUrls: ['./epbt-fa-contacts-grid.component.scss']
})
export class EpbtFaContactsGridComponent implements OnInit {
  EpButtonStyle = EpButtonStyle;

  contacts: any = [];
  private _searchString: string;
  @Input('searchString') set searchString(value: string) {
    this._searchString = value;
  }
  get searchString(): string { return this._searchString; }
  @Input() customerId: number;
  @ViewChild('emailTemplate', {static: false}) emailTemplate: TemplateRef<any>;
  @ViewChild('telTemplate', {static: false}) telTemplate: TemplateRef<any>;
  @ViewChild('mobileTemplate', {static: false}) mobileTemplate: TemplateRef<any>;
  @ViewChild('faxTemplate', {static: false}) faxTemplate: TemplateRef<any>;
  @ViewChild('webTemplate', {static: false}) webTemplate: TemplateRef<any>;
  gridModel: IEpGridModel;
  pageSize = 10;

  @Output() loadingChange = new EventEmitter<boolean>();
  contactsCollection: any = [];
  totalPages = 1;
  showGrid = true;
  pageArray: Array<number> = [];
  lastPage: number;
  lastRecords: any;
  mobileData: any;
  isLastRecords = false;
  isMoreEnable = false;
  // pat = /^https?:\/\//i;
  @Input() formDashboard = false;

  constructor(private client: FieldAgentClient, private router: Router,
    private config: BistrackConfig,
    private fieldAgentService: EpbtFieldAgentService,
    public customerService: EpbtFaCustomerService,
    private location: Location,
    private quickOrderService: EpbtFaQuickOrderService,
    private contactsService: EpbtFaContactsService,
    private sortService: EpbtFaSortService) { }

  ngOnInit() {
    this.fieldAgentService.getBisTrackSetting((bistrackSettings: any) => {
      this.pageSize = bistrackSettings.searchPageSize;
      if ((this.customerId && this.customerId != -1) || this.searchString || this.searchString == '') {
        this.gridModel = this.getGridModel([]);
      }
    });
  }

  getGridModel(contactsList): IEpGridModel {
    const selectionOptions: IEpGridSelectionOptions = {
      selectByField: 'name',
      selectedKeys: [],
    };
    const model: IEpGridModel = {
      resizable: false,
      reorderable: false,
      groupable: false,
      filterable: false,
      pageable: true,
      pageSize: this.pageSize,
      scrollable: 'scrollable',
      rowHeight: 20,
      sortable: false,
      height: this.getHeight(),
      selectionOptions: selectionOptions,
      selectable: this.quickOrderService.isNewOrder ? true : false,
      data: contactsList,
      columns: [
        { field: 'name', title: 'CONTACT NAME', width: 30, hidden: false },
        { field: 'customerCode', title: 'CUSTOMER CODE', width: 30, hidden: !this.customerService.isContactDashboard },
        { field: 'customerName', title: 'CUSTOMER NAME', width: 30, hidden: !this.customerService.isContactDashboard },
        { field: 'telephone', title: 'TELEPHONE', width: 25, hidden: false, class: 'color-blue', cellTemplate: this.telTemplate },
        { field: 'mobile', title: 'MOBILE', width: 25, hidden: false, class: 'color-blue', cellTemplate: this.mobileTemplate },
        { field: 'email', title: 'EMAIL', width: 25, hidden: false, class: 'color-blue', cellTemplate: this.emailTemplate },
        { field: 'fax', title: 'FAX', width: 25, hidden: false, class: 'color-blue', cellTemplate: this.faxTemplate },
        { field: 'webAddress', title: 'WEB ADDRESS', width: 25, hidden: false, class: 'color-blue', cellTemplate: this.webTemplate },
      ],
      epOnComponentEvent: (eventArg: IEpComponentEventArg) => {
        if (eventArg.eventId == 'epOnCellClick' && eventArg.event && eventArg.event.type == 'click') {
          this.navigateTo(eventArg.event.dataItem);
        }
      },
      loader: (epGrid: EpGridComponent, state: IEpGridState) => {
        const observerResult = this.getGridModelData(epGrid, state, contactsList, false);
        return observerResult;
      }
    };

    $(window).resize(() => {
      this.updateGrid();
    });

    return model;
  }


  getGridModelData(epGrid: EpGridComponent, state: IEpGridState, contactsList, isMobile: boolean): Observable<IEPGridDataResult> {
    const observerResult = new Observable<IEPGridDataResult>(observer => {
      if (!isMobile) {
        epGrid.model.loadingIndicator = true;
      }
      const index = state.skip + state.take;
      const pageNumber = Math.ceil(index / state.take);
      const pageIndex = this.pageArray.indexOf(pageNumber);
      if ((pageIndex >= 0 && !isMobile) || (pageNumber == this.lastPage && this.lastRecords && this.lastRecords.length > 0 && !isMobile)) {
        epGrid.model.loadingIndicator = false;
        const showoff = pageNumber == this.lastPage ? this.lastRecords : this.contactsCollection.slice(state.take * pageIndex, (state.take * pageIndex) + state.take);
        const result: IEPGridDataResult = {
          data: showoff,
          total: this.totalPages
        };
        observer.next(result);
        observer.complete();
      } else {
        const searchCustomerParams = new CustomerSearchParameters();
        searchCustomerParams.customerStatus = CustomerSearchParametersCustomerStatus.CustomerOrProspect;
        //  searchCustomerParams.webTrackCustomersOnly = false;
        //  searchCustomerParams.searchPermissions = null;
        searchCustomerParams.customersLimitSearchToHomeBranch = true;
        //  searchCustomerParams.restrictCustomersToSalesRep = false;
        searchCustomerParams.bisTrackUserID = this.config.getLoggedinUser();
        searchCustomerParams.competitor = 0;
        const page = new PagingParameters();
        page.index = state.skip;
        page.count = this.pageSize;
        searchCustomerParams.paging = page;
        const sort = new SortParameters();
        if (this.sortService.currentPageName == SearchPageNames.CustomerContactSearch) {
          sort.sortColumn = this.sortService.customerConatctSortValue;
          sort.direction = this.sortService.customerConatctDirectionValue == 0 ? SortParametersDirection.Ascending : SortParametersDirection.Descending;
        } else {
          sort.sortColumn = this.sortService.dashboardConatctSortValue;
          sort.direction = this.sortService.dashboardConatctDirectionValue == 0 ? SortParametersDirection.Ascending : SortParametersDirection.Descending;
        }

        searchCustomerParams.sorting = sort;
        searchCustomerParams.searchText = this._searchString;
        searchCustomerParams.deliverytype = CustomerSearchParametersDeliverytype.All;
        searchCustomerParams.productGroupId = 0;
        searchCustomerParams.quicklistId = 0;
        searchCustomerParams.showProductsInCurrentGroupOnly = false;
        searchCustomerParams.customerId = this.customerId ? this.customerId : -1;

        searchCustomerParams.restrictProductGroupsToCustomer = false;
        searchCustomerParams.refineIDs = null;
        searchCustomerParams.refineValues = null;
        searchCustomerParams.priceLevels = null;
        searchCustomerParams.branchID = 0;
        searchCustomerParams.bisTrackUserHasReadAccessToTheseBranchIDs = null;
        searchCustomerParams.defaultOnly = false;
        searchCustomerParams.includeMOLTProducts = false;
        this.client.findContacts(searchCustomerParams).subscribe(res => {
          contactsList = res.lines;

          if (contactsList != null && contactsList != undefined && contactsList.length > 0) {
            this.totalPages = res.resultCount;
            this.lastPage = Math.ceil(this.totalPages / state.take);
            if (pageNumber != this.lastPage) {
              this.pageArray.push(pageNumber);
            }

            if (!isMobile) {
              epGrid.model.loadingIndicator = false;
            }
            if (contactsList.length < state.take) {
              this.lastRecords = contactsList;
            } else {
              this.contactsCollection = [...this.contactsCollection, ...contactsList];
            }
            if (!isMobile) {
              this.mobileData = this.contactsCollection;
              if (this.lastRecords && this.lastRecords.length > 0) {
                this.mobileData = [...this.mobileData, ...this.lastRecords];
              }
              this.isMoreEnable = this.mobileData.length == this.totalPages ? false : true;
            }

            length = this.contactsCollection.length;
            const result: IEPGridDataResult = {
              data: contactsList,
              total: this.totalPages
            };
            observer.next(result);
            observer.complete();
          } else {
            const result: IEPGridDataResult = {
              data: [],
              total: 0
            };
            observer.next(result);
            observer.complete();
            if (!isMobile) {
              epGrid.model.loadingIndicator = false;
            }
            this.isMoreEnable = false;
            this.mobileData = this.mobileData ? this.mobileData : [];
          }
        });
      }
      this.loadingChange.emit(false);
    });
    return observerResult;
  }

  updateGrid() {
    const calHeight = this.getHeight();
    this.gridModel.height = calHeight;
  }

  getHeight(): number {
    let height;
    if (this.formDashboard) {
      height = $(window).outerHeight() - 192;
    } else {
      height = $(window).outerHeight() - 300;
    }

    const width = parseInt($('body').width());

    if (width > 250 && width < 1023) {
      // mobile and ipad
      return 400;
    }
    return height;
  }

  getMobileData() {
    const take = this.pageSize;
    for (let i = 1; i <= this.lastPage; i++) {
      const index = this.pageArray.indexOf(i);
      if (index == -1) {
        const state: IEpGridState = {
          skip: (i - 1) * take,
          take: take
        };
        let epGrid: EpGridComponent;
        let contactsList;
        this.getGridModelData(epGrid, state, contactsList, true).subscribe(res => {
          if (res.data && res.data.length > 0) {
            let j = 0;
            if (res.data.length == state.take) {
              res.data.forEach(element => {
                this.mobileData.splice((state.take * (i - 1)) + j, 0, element);
                j++;
              });
            }
            if (this.lastRecords && this.lastRecords.length > 0 && !this.isLastRecords) {
              this.mobileData = [...this.mobileData, ...this.lastRecords];
              this.isLastRecords = true;
            }
            this.isMoreEnable = this.mobileData.length == this.totalPages ? false : true;
          }
        });
        break;
      }
    }
  }

  updateContactsGridData() {
    this.lastPage = 0;
    this.lastRecords = undefined;
    this.mobileData = undefined;
    this.isLastRecords = false;
    this.pageArray.length = 0;
    this.isMoreEnable = false;
    this.gridModel = undefined;
    this.showGrid = false;
    this.contactsCollection.length = 0;
    setTimeout(() => {
      this.showGrid = true;
      this.loadingChange.emit(true);
      this.gridModel = this.getGridModel([]);
    }, 200);
  }

  onCardClick(model) {
    this.navigateTo(model);
  }

  Clickweb(uriString: string) {
    //     var pat = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gm
    //     // pat=/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gm
    //  let urls:string;
    //  urls.st
    //     if (pat.test(link)) {
    //       window.open(link);
    //     }
    //     else {
    //       var strCheck = 'http://' + link;
    //       //'http://'+ link+'.com'
    //       // this.navigateTo('https://'+ link)
    //       console.log(strCheck);
    //       window.open(strCheck);
    //     }

    // let uriString: string = '';
    if (!isNaN(Number(uriString)) && uriString.length > 10) {
      window.open(); return;
    } else if (!(uriString.toLowerCase().startsWith('http:' + '//') || uriString.toLowerCase().startsWith('https:' + '//'))) {
      uriString = 'http:' + '//' + uriString;
    }
    window.open(uriString);
    // return uriString;
  }

  navigateTo(args) {
    localStorage.setItem(LocalStorageSaveTypes.Type, LocalStorageSaveTypes.Edit);
    const id = args.customerContactID;
    if (this.customerService.fromPage == PageNames.QuickOrder) {
      if (!this.quickOrderService.isNewOrder) {
        this.quickOrderService.quickOrder.contact = args;
        this.customerService.fromPage = PageNames.CustomerSearch;
        this.router.navigate(['/home/quickorder']);
      } else {
        this.quickOrderService.contactForDesktop = args;
      }
    } else {
      localStorage.setItem(LocalStorageSaveTypes.CustomerName, args.customerName);
      this.contactsService.customerContact = null;
      this.router.navigate(['/home/contact/addcontact', id]);
    }

    this.contactsService.fromPage = PageNames.ContactsSearch;
  }
}
